import { styled } from '@ori-ui/mui';

export const Root = styled('div')(({ theme }) => ({
  alignItems: 'center',
  alignSelf: 'flex-end',
  display: 'flex',
  position: 'relative',
  width: 125,

  [theme.breakpoints.up('md')]: {
    alignSelf: 'center',
    flexShrink: 0,
  },
}));
